import { IGetAnalyticsValue, ISendAnalyticsProps } from './types'
import { sendToApp } from './webViewBridge'

const getAnalyticsValues = ({ screen, type }: IGetAnalyticsValue) => {
  const baseConfig: Record<
    IGetAnalyticsValue['screen'],
    { label: string; action: string }
  > = {
    SHOW_PRIMARY_DETAILS_SCREEN_JFS: {
      label: 'User Details',
      action: 'user_detail',
    },
    SHOW_BASIC_DETAILS_SCREEN_JFS: {
      label: 'Basic Details',
      action: 'basic_detail',
    },
    SHOW_PAN_SCREEN_JFS: {
      label: 'PAN Screen',
      action: 'pan_detail',
    },
    SHOW_QUICK_RECOMMENDATION_SCREEN: {
      label: 'Recommendation List',
      action: 'recommendation_list',
    },
    FILTERSCREEN_SCREEN_LOAD: {
      label: 'Filter Screen',
      action: 'filter_load',
    },
    SORTSCREEN_SCREEN_LOAD: {
      label: 'Sort Screen',
      action: 'sort_load',
    },
    FILTERSCREEN_SCREEN_CTA: {
      label: 'Filter Screen',
      action: 'filter_applied',
    },
    SORTSCREEN_SCREEN_CTA: {
      label: 'Sort Screen',
      action: 'sort_applied',
    },
    EDITDETAIL_CTA: {
      label: 'Edit Details Screen',
      action: 'edit_details',
    },
  }

  const config = baseConfig[screen]
  if (!config) return undefined

  const eventSuffix = type === 'screen' ? 'SCREEN_LOAD' : 'SCREEN_CTA'
  const event = `ZET_${config.action.toUpperCase()}_${eventSuffix}`

  return {
    ...config,
    event,
  }
}

const removeNonLatin1Chars = (obj: object): object => {
  const replacer = (value: any): any => {
    if (typeof value === 'string') {
      // Remove characters outside Latin1 (ISO-8859-1)
      return value.replace(/[^\x00-\xFF]/g, '')
    } else if (Array.isArray(value)) {
      return value.map(replacer)
    } else if (typeof value === 'object' && value !== null) {
      return Object.fromEntries(
        Object.entries(value).map(([k, v]) => [k, replacer(v)])
      )
    }
    return value
  }

  return replacer(obj)
}

const sendAnalyticsData = ({
  screen,
  type,
  optional_data,
}: ISendAnalyticsProps) => {
  const analyticsValues = getAnalyticsValues({ screen, type })
  if (!analyticsValues) return

  const { label, action, event } = analyticsValues

  const cleanedOptionalData = optional_data
    ? JSON.stringify(removeNonLatin1Chars(optional_data))
    : ''

  const analyticsData = {
    type: 'web_ga',
    value: type,
    screenName: label,
    gaTag: {
      event,
      category: 'Mobile',
      action,
      label,
      general_data: '',
      optional_data: cleanedOptionalData,
      ctEvent: true,
      firebaseEvent: true,
      appsflyerEvent: true,
      clickStreamEvents: true,
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_campaign_id: '',
      ifa: 'ifa',
    },
  }

  sendToApp(analyticsData)
}

export { getAnalyticsValues, sendAnalyticsData }
